export const CHAIN_INFO = {
  chainId: 'tDVV',
  exploreUrl: 'https://aelfscan.io/tDVV/',
  rpcUrl: 'https://tdvv-public-node.aelf.io',
};

export const TOKEN_CONTRACT = '7RzVGiuVWkvL4VfVHdZfQF2Tri3sgLe9U991bohHFfSRZXuGX';
export const ETRANSFER_CONTRACT = 'x4CTSuM8typUbpdfxRZDTqYVa42RdxrwwPkXX7WUJHeRmzE6k';
export const CA_CONTRACT = '2cLA9kJW3gdHuGoYNY16Qir69J3Nkn6MSsuYxRkUHbz4SG2hZr';
export const CA_CONTRACT_V2 = '2UthYi7AHRdfrqc1YCfeQnjdChDLaas65bW4WxESMGMojFiXj9';
